/* ==========================================================================
   ZPK — Comportamenti J-POP
   Nessuna dipendenza esterna. Tutto delegato sul document, così funziona
   anche quando il theme editor rirenderizza una sezione.
   ========================================================================== */
(function () {
  'use strict';

  /* --- Utilità ---------------------------------------------------------- */
  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function safeSession(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      if (action === 'set') window.sessionStorage.setItem(key, value);
    } catch (e) { /* storage negato: si degrada senza rompere */ }
    return null;
  }

  /* --- Annunci per screen reader ----------------------------------------
     Senza questa regione, aggiungere al carrello da una card non produce
     nessun riscontro udibile: il pulsante viene premuto e non succede niente
     di percepibile. E' il criterio WCAG 4.1.3 (Messaggi di stato, AA).
     La regione deve esistere PRIMA che il testo cambi, altrimenti gli screen
     reader non annunciano nulla: per questo si crea all'avvio. */
  let liveRegion;
  function announce(message) {
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.className = 'zpk-visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    window.setTimeout(() => { liveRegion.textContent = message; }, 60);
  }

  /* --- Barra promo ------------------------------------------------------ */
  function initPromo(root) {
    $$('.zpk-promo', root).forEach((bar) => {
      const key = 'zpk-promo-' + (bar.dataset.promoId || 'default');
      if (safeSession('get', key) === 'closed' && !window.Shopify?.designMode) {
        bar.hidden = true;
        return;
      }
      const close = $('.zpk-promo__close', bar);
      if (!close || close.dataset.zpkBound) return;
      close.dataset.zpkBound = '1';
      close.addEventListener('click', () => {
        bar.hidden = true;
        safeSession('set', key, 'closed');
      });
    });
  }

  /* --- Carosello generico (traccia con scroll-snap) --------------------- */
  // Chi ha chiesto meno animazioni non deve subire lo scorrimento animato.
  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  // Scorre di una schermata: tante card quante se ne vedono (4 su desktop).
  // Nel banner una slide e' larga quanto la traccia, quindi resta una slide.
  function scrollByPage(track, dir) {
    const first = track.firstElementChild;
    if (!first) return;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    const step = first.getBoundingClientRect().width + gap;
    const perView = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    track.scrollBy({ left: dir * perView * step, behavior: scrollBehavior() });
  }

  // Ai due capi la freccia che non porta da nessuna parte si spegne. Con
  // aria-disabled e non disabled: un bottone disabilitato perde il focus, e
  // chi scorre da tastiera si ritroverebbe in cima alla pagina.
  function syncArrows(wrap, track) {
    const max = track.scrollWidth - track.clientWidth;
    $$('[data-zpk-prev]', wrap).forEach((b) => b.setAttribute('aria-disabled', String(track.scrollLeft <= 1)));
    $$('[data-zpk-next]', wrap).forEach((b) => b.setAttribute('aria-disabled', String(track.scrollLeft >= max - 1)));
  }

  // Una freccia che non scorre nulla e' peggio che assente: resta nell'ordine
  // di tabulazione e viene annunciata come comando disponibile. Quando la
  // traccia non e' scorrevole, le frecce spariscono. Vale anche per i puntini.
  const tracked = [];

  // Dove portare lo scorrimento perche' la card di indice `index` finisca
  // all'inizio. Il riquadro va preso con getBoundingClientRect e non con
  // offsetLeft: nel mazzo "Suggeriti" le card laterali sono ruotate, e il
  // punto di aggancio che usa il browser e' il loro ingombro trasformato,
  // non la scatola di layout.
  function slideOffset(track, index) {
    const slide = track.children[index];
    if (!slide) return null;
    const pad = parseFloat(getComputedStyle(track).scrollPaddingInlineStart) || 0;
    return track.scrollLeft
      + slide.getBoundingClientRect().left
      - track.getBoundingClientRect().left
      - pad;
  }

  // Un puntino per prodotto. Quelli che cadono oltre la corsa dello
  // scorrimento non porterebbero da nessuna parte: si nascondono, come le
  // frecce. Il corrente e' quello piu' vicino alla posizione attuale.
  function syncDots(wrap, track) {
    const dots = $$('[data-zpk-dot]', wrap);
    if (!dots.length) return;
    const max = track.scrollWidth - track.clientWidth;
    let current = 0;
    let best = Infinity;
    dots.forEach((dot, i) => {
      const target = slideOffset(track, i);
      const reachable = target !== null && (i === 0 || target <= max + 1);
      dot.hidden = !reachable;
      if (!reachable) return;
      // La slide oltre la corsa si raggiunge a fine corsa: si confronta li'.
      const distance = Math.abs(Math.min(target, max) - track.scrollLeft);
      if (distance < best) { best = distance; current = i; }
    });
    dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
  }

  function syncControls(wrap, track) {
    const scrollable = track.scrollWidth > track.clientWidth + 1;
    $$('[data-zpk-prev], [data-zpk-next]', wrap).forEach((b) => { b.hidden = !scrollable; });
    const dotGroup = $('[data-zpk-dots]', wrap);
    if (dotGroup) dotGroup.hidden = !scrollable;
    // L'hero ha i suoi puntini (initHero): uno per slide, tutti raggiungibili,
    // l'ultimo a fine corsa. La regola dei caroselli prodotti (si nasconde il
    // puntino che cade oltre la corsa) spegneva la seconda slide dove se ne
    // vedono due insieme.
    if (scrollable && !wrap.matches('[data-zpk-hero]')) syncDots(wrap, track);
    if (scrollable && wrap.matches('[data-zpk-carousel]')) syncArrows(wrap, track);
  }

  function syncAllControls() {
    tracked.forEach(([wrap, track]) => syncControls(wrap, track));
  }

  // Va rifatto quando cambia la larghezza (rotazione del telefono, finestra
  // ridimensionata) e quando le immagini finiscono di caricare, perche' fino
  // a quel momento la traccia puo' misurare meno del vero.
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAllControls, 150);
  });
  window.addEventListener('load', syncAllControls);

  /* Trascinamento col mouse: premi e trascina fa scorrere la traccia, come
     col dito sul telefono (dove lo scorrimento e' gia' del browser, quindi
     qui si guarda solo il mouse). Durante il trascinamento lo scroll-snap e'
     spento, altrimenti la traccia scatterebbe a ogni pixel; al rilascio si
     aggancia alla card piu' vicina. Un trascinamento non e' un clic: il clic
     che arriva subito dopo si annulla, cosi' non si apre la card. */
  function snapToNearest(track) {
    const max = track.scrollWidth - track.clientWidth;
    let best = track.scrollLeft;
    let distance = Infinity;
    Array.from(track.children).forEach((_, i) => {
      const target = Math.min(slideOffset(track, i), max);
      const d = Math.abs(target - track.scrollLeft);
      if (d < distance) { distance = d; best = target; }
    });
    track.scrollTo({ left: best, behavior: scrollBehavior() });
  }

  function initDrag(track) {
    let pointerId = null;
    let startX = 0;
    let startLeft = 0;
    let dragging = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea')) return;   // carrello, cuore
      pointerId = event.pointerId;
      startX = event.clientX;
      startLeft = track.scrollLeft;
      dragging = false;
    });

    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 6) return;   // sotto i 6px e' ancora un clic
        dragging = true;
        track.setPointerCapture(pointerId);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startLeft - dx;
    });

    const end = (event) => {
      if (event.pointerId !== pointerId) return;
      pointerId = null;
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      snapToNearest(track);
      const swallow = (click) => { click.preventDefault(); click.stopPropagation(); };
      track.addEventListener('click', swallow, { capture: true, once: true });
      window.setTimeout(() => track.removeEventListener('click', swallow, { capture: true }), 0);
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    // Il browser trascinerebbe la copertina o il link come file.
    track.addEventListener('dragstart', (event) => event.preventDefault());
  }

  function initCarousels(root) {
    $$('[data-zpk-carousel]', root).forEach((wrap) => {
      if (wrap.dataset.zpkBound) return;
      wrap.dataset.zpkBound = '1';
      const track = $('[data-zpk-track]', wrap);
      if (!track) {
        // Nessuna traccia: qualunque freccia presente sarebbe inerte.
        $$('[data-zpk-prev], [data-zpk-next]', wrap).forEach((b) => { b.hidden = true; });
        $$('[data-zpk-dots]', wrap).forEach((g) => { g.hidden = true; });
        return;
      }
      $$('[data-zpk-prev]', wrap).forEach((b) => b.addEventListener('click', () => scrollByPage(track, -1)));
      $$('[data-zpk-next]', wrap).forEach((b) => b.addEventListener('click', () => scrollByPage(track, 1)));

      const dots = $$('[data-zpk-dot]', wrap);
      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        const target = slideOffset(track, i);
        if (target !== null) track.scrollTo({ left: target, behavior: scrollBehavior() });
      }));
      // Puntini e frecce seguono lo scorrimento vero, anche quando arriva da
      // un trascinamento col dito o dalla rotella, non da un clic.
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          if (dots.length) syncDots(wrap, track);
          syncArrows(wrap, track);
        });
      }, { passive: true });

      initDrag(track);
      tracked.push([wrap, track]);
      syncControls(wrap, track);
    });
  }

  /* --- «Il tuo mood»: le frecce cambiano mood ---------------------------
     Un pannello per mood, tutti stampati dal server; se ne vede uno alla
     volta, gli altri hanno `hidden`. Le frecce girano in tondo e cambiano
     insieme fumetti e sottotitolo; il sottotitolo e' aria-live, quindi lo
     screen reader legge il nome del mood nuovo (WCAG 4.1.3). Nessuno
     scorrimento: a differenza dei caroselli qui non c'e' una traccia.

     I colori: ogni pannello porta in data-zpk-mood-style le dichiarazioni gia'
     scritte dal Liquid (--zpk-mood-bg, -bg-2, -fg). Qui si copiano sulla
     sezione e basta: nessun conto sui colori nel JS, e il fondo scivola da solo
     perche' quelle tre proprieta' sono registrate e in transizione (CSS). */
  function initMoods(root) {
    $$('[data-zpk-moods]', root).forEach((wrap) => {
      if (wrap.dataset.zpkBound) return;
      wrap.dataset.zpkBound = '1';
      const panels = $$('[data-zpk-mood]', wrap);
      const label = $('[data-zpk-mood-label]', wrap);
      const arrows = $$('[data-zpk-mood-prev], [data-zpk-mood-next]', wrap);
      // Con un mood solo le frecce non servono: il Liquid non le stampa, e se
      // ci fossero resterebbero comandi inerti raggiungibili col tab.
      if (panels.length < 2) {
        arrows.forEach((b) => { b.hidden = true; });
        return;
      }
      let current = Math.max(0, panels.findIndex((p) => !p.hidden));
      const paint = (panel) => {
        const style = panel.dataset.zpkMoodStyle;
        // Senza colore la sezione torna alla riserva del CSS: il gradiente di
        // marca. L'attributo si toglie del tutto, non si svuota.
        if (style) wrap.setAttribute('style', style);
        else wrap.removeAttribute('style');
      };
      const show = (index) => {
        const next = ((index % panels.length) + panels.length) % panels.length;
        if (next === current && !panels[next].hidden) return;
        panels.forEach((p, i) => { p.hidden = i !== next; });
        current = next;
        paint(panels[next]);
        if (label) label.textContent = panels[next].dataset.zpkMood || '';
      };
      $$('[data-zpk-mood-prev]', wrap).forEach((b) => b.addEventListener('click', () => show(current - 1)));
      $$('[data-zpk-mood-next]', wrap).forEach((b) => b.addEventListener('click', () => show(current + 1)));
      // Per il theme editor: selezionando un blocco mood si vede quel mood.
      wrap.zpkShowMood = (panel) => {
        const i = panels.indexOf(panel);
        if (i >= 0) show(i);
      };
    });
  }

  /* --- Hero: frecce + puntini -------------------------------------------
     Le frecce girano in tondo (richiesta del cliente, 23 settembre 2026):
     dopo l'ultima slide si torna alla prima, e dalla prima la freccia
     indietro porta all'ultima. Per questo qui le frecce non si spengono mai
     ai capi, a differenza dei caroselli prodotti. */
  function initHero(root) {
    $$('[data-zpk-hero]', root).forEach((hero) => {
      if (hero.dataset.zpkBound) return;
      hero.dataset.zpkBound = '1';
      const track = $('[data-zpk-track]', hero);
      const dots  = $$('[data-zpk-dot]', hero);
      if (!track) return;

      // Si ragiona per slide e non per pixel: con lo scroll-snap l'ultima
      // slide si aggancia prima della fine della corsa (1197 su 1351 a 1280
      // di finestra), quindi «sono alla fine?» non si puo' chiedere a
      // scrollLeft. La slide corrente e' quella agganciata piu' vicina.
      const currentIndex = () => {
        const max = track.scrollWidth - track.clientWidth;
        let current = 0;
        let best = Infinity;
        for (let i = 0; i < track.children.length; i += 1) {
          const d = Math.abs(Math.min(slideOffset(track, i), max) - track.scrollLeft);
          if (d < best) { best = d; current = i; }
        }
        return current;
      };
      const step = (dir) => {
        const count = track.children.length;
        if (!count) return;
        const max = track.scrollWidth - track.clientWidth;
        const next = (currentIndex() + dir + count) % count;
        track.scrollTo({ left: Math.min(slideOffset(track, next), max), behavior: scrollBehavior() });
      };
      $$('[data-zpk-prev]', hero).forEach((b) => b.addEventListener('click', () => step(-1)));
      $$('[data-zpk-next]', hero).forEach((b) => b.addEventListener('click', () => step(1)));
      tracked.push([hero, track]);
      syncControls(hero, track);

      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        const slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: scrollBehavior() });
      }));

      // Il puntino acceso e' la slide agganciata, dalla posizione di
      // scorrimento. Prima lo decideva un IntersectionObserver (visibile al
      // 60%): dove si vedono due slide insieme (card da 420 su uno schermo
      // da 716) si accendeva la seconda anche con la prima davanti.
      if (dots.length) {
        let frame = 0;
        const syncDots = () => {
          frame = 0;
          const idx = currentIndex();
          dots.forEach((d, i) => d.setAttribute('aria-current', String(i === idx)));
        };
        track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(syncDots); }, { passive: true });
        window.addEventListener('resize', () => { if (!frame) frame = requestAnimationFrame(syncDots); }, { passive: true });
        syncDots();
      }
    });
  }

  /* --- Selettore quantità ------------------------------------------------ */
  function initQty(root) {
    $$('[data-zpk-qty]', root).forEach((wrap) => {
      if (wrap.dataset.zpkBound) return;
      wrap.dataset.zpkBound = '1';
      const input = $('input', wrap);
      if (!input) return;
      const step = (delta) => {
        const min = parseInt(input.min || '1', 10);
        const next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      $('[data-zpk-qty-minus]', wrap)?.addEventListener('click', () => step(-1));
      $('[data-zpk-qty-plus]', wrap)?.addEventListener('click', () => step(1));
    });
  }

  /* --- Galleria prodotto ------------------------------------------------- */
  function initGallery(root) {
    $$('[data-zpk-gallery]', root).forEach((gallery) => {
      if (gallery.dataset.zpkBound) return;
      gallery.dataset.zpkBound = '1';
      const main = $('[data-zpk-gallery-main]', gallery);
      if (!main) return;
      $$('[data-zpk-gallery-thumb]', gallery).forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.zpkGalleryThumb;
          const alt = thumb.dataset.zpkGalleryAlt || '';
          if (src) { main.src = src; main.alt = alt; main.removeAttribute('srcset'); }
          $$('[data-zpk-gallery-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
        });
      });
    });
  }

  /* --- «Leggi di più» sotto la descrizione --------------------------------
     Il bottone c'e' nel render, ma va acceso solo quando il testo e' davvero
     piu' lungo di quanto si vede: se la descrizione sta tutta dentro le
     quattro righe, un comando che non fa nulla resterebbe raggiungibile col
     tab e annunciato dallo screen reader. E' lo stesso criterio gia' usato
     per le frecce dei caroselli e per quelle del banner lettore. */
  function initReadMore(root) {
    $$('[data-zpk-more]', root).forEach((btn) => {
      if (btn.dataset.zpkBound) return;
      btn.dataset.zpkBound = '1';
      const body = document.getElementById(btn.dataset.zpkMore);
      if (!body) return;

      const sync = () => {
        if (btn.getAttribute('aria-expanded') === 'true') return;
        body.setAttribute('data-zpk-clamped', '');
        btn.hidden = body.scrollHeight <= body.clientHeight + 1;
        if (btn.hidden) body.removeAttribute('data-zpk-clamped');
      };
      sync();
      // Le immagini e i font che arrivano dopo cambiano l'altezza vera.
      window.addEventListener('load', sync);
      window.addEventListener('resize', () => { clearTimeout(btn._t); btn._t = setTimeout(sync, 150); });

      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) body.setAttribute('data-zpk-clamped', '');
        else body.removeAttribute('data-zpk-clamped');
      });
    });
  }

  /* --- Menu mobile ------------------------------------------------------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  // A menu aperto il fuoco deve restare dentro: senza, il tab prosegue sui
  // contenuti coperti dall'overlay, che sono invisibili ma ancora attivi.
  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    const menu = $('#zpk-mobile-menu');
    if (!menu || !menu.classList.contains('is-open')) return;
    const items = $$(FOCUSABLE, menu).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    } else if (!menu.contains(document.activeElement)) {
      event.preventDefault(); first.focus();
    }
  }

  // Il comando del blocco app nell'header: un div role="button" con
  // data-wishlist-header (letto dal DOM il 21 settembre 2026).
  const WISHLIST_HEART = '.zpk-header__wishlist [data-wishlist-header], .zpk-header__wishlist [role="button"], .zpk-header__wishlist button';

  // Il numero accanto a «Lista dei desideri» si copia, all'apertura del
  // menu, dal contatore che l'app disegna sul cuore. Il contatore l'app lo
  // mette solo a lista non vuota: senza, il numero non si mostra.
  function syncWishlistCount(menu) {
    const out = $('[data-zpk-wishlist-count]', menu);
    if (!out) return;
    const bubble = $('.zpk-header__wishlist .wishlist-count-bubble');
    const n = parseInt(bubble ? bubble.textContent : '', 10);
    out.hidden = !(n > 0);
    if (!(n > 0)) return;
    const hint = document.createElement('span');
    hint.className = 'zpk-visually-hidden';
    hint.textContent = n === 1 ? ' prodotto' : ' prodotti';
    out.replaceChildren(String(n), hint);
  }

  function initMobileMenu() {
    if (document.body.dataset.zpkMenuBound) return;
    document.body.dataset.zpkMenuBound = '1';
    document.addEventListener('keydown', trapFocus);
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-zpk-menu-open]');
      const closer = event.target.closest('[data-zpk-menu-close]');
      if (!opener && !closer) return;
      const menu = $('#zpk-mobile-menu');
      if (!menu) return;
      const open = Boolean(opener);
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      // Lo stato del bottone va aggiornato, altrimenti chi usa uno screen
      // reader sente sempre "compresso" anche a menu aperto.
      $$('[data-zpk-menu-open]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
      if (open) syncWishlistCount(menu);
      if (open) $('a, button', menu)?.focus();
      else document.querySelector('[data-zpk-menu-open]')?.focus();
    });
    // Tendina dei generi: la freccia accanto a Manga, Fumetti… apre e chiude
    // l'elenco sotto la voce. La parola resta un link alla categoria.
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-zpk-mm-toggle]');
      if (!toggle) return;
      const list = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!list) return;
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      list.hidden = !open;
    });
    // «Lista dei desideri» in fondo al menu: sotto i 990 il cuore di Magic
    // Wishlist e' nascosto nell'header ma c'e' ancora. Si chiude il menu (il
    // fuoco torna al burger) e si preme il cuore: si apre il pannello
    // dell'app, lo stesso che si apre dall'header sopra i 990.
    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-zpk-wishlist-open]')) return;
      const heart = $(WISHLIST_HEART);
      if (!heart) return;
      $('[data-zpk-menu-close]')?.click();
      heart.click();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      // Esc dentro il riquadro account chiude solo quello: il menu resta.
      if (event.composedPath().some((el) => el.localName === 'shopify-account')) return;
      const menu = $('#zpk-mobile-menu');
      if (menu?.classList.contains('is-open')) {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        $$('[data-zpk-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        document.querySelector('[data-zpk-menu-open]')?.focus();
      }
    });
  }

  /* --- Account (<shopify-account>) --------------------------------------- */
  // Il riquadro di Shopify si apre dal bottone nel suo shadow DOM (aperto).
  // In fondo al menu mobile quel bottone e' largo quanto il suo contenuto
  // (i contenitori interni non si possono allargare): il clic sul resto del
  // bottone giallo, o su «Il mio account» accanto all'iniziale del cliente
  // collegato, preme il bottone del componente. Il nome accessibile che Shopify
  // mette al suo bottone e' «Account»: lo si fa diventare quello del sito.
  function initAccount() {
    document.addEventListener('click', (event) => {
      const row = event.target.closest('.zpk-mobilemenu__account');
      if (!row) return;
      const btn = $('shopify-account', row)?.shadowRoot?.querySelector('button');
      // Clic sul bottone vero (o dentro il riquadro gia' aperto): fa da se'.
      // Il componente occupa tutta la riga, quindi non basta guardare se il
      // clic cade dentro <shopify-account>: conta se passa dal suo bottone.
      const path = event.composedPath();
      if (!btn || path.includes(btn) || path.some((n) => n.localName === 'dialog')) return;
      // Al turno dopo: aperto durante questo stesso clic, il riquadro lo
      // prendeva per un clic fuori e si richiudeva subito.
      setTimeout(() => btn.click(), 0);
    });
    // Dall'header il riquadro scende sotto la fila dell'header e finisce
    // dove finiscono le icone, cioe' sul margine destro del contenuto
    // (Shopify lo mette a 20px dal bordo della finestra: sugli schermi
    // larghi restava staccato, tutto a destra; segnalato il 6/10/2026). Il
    // clic si intercetta in cattura, prima che il componente apra il
    // riquadro; il lato destro lo applica zpk-theme.css, § Account.
    document.addEventListener('click', (event) => {
      const el = event.composedPath().find((node) => node.localName === 'shopify-account');
      const header = el?.closest('.zpk-header');
      if (!header) return;
      const top = Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 8;
      el.style.setProperty('--shopify-account-dialog-position-top', `${top}px`);
      const actions = el.closest('.zpk-header__actions') || header;
      const end = document.documentElement.clientWidth - actions.getBoundingClientRect().right;
      el.style.setProperty('--zpk-account-end', `${Math.max(0, Math.round(end))}px`);
    }, true);
    const label = () => $$('shopify-account').forEach((el) => {
      const btn = el.shadowRoot?.querySelector('button[aria-haspopup]');
      if (!btn) return;
      const signedIn = !btn.matches('[part~="signed-out-avatar"]');
      const name = signedIn ? 'Il mio account' : 'Accedi o registrati';
      if (btn.getAttribute('aria-label') !== name) btn.setAttribute('aria-label', name);
    });
    customElements.whenDefined('shopify-account').then(() => {
      label();
      // Il componente ridisegna il bottone quando cambia stato (accesso
      // fatto dal riquadro): si rimette il nome.
      $$('shopify-account').forEach((el) => {
        if (el.shadowRoot) new MutationObserver(label).observe(el.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label'] });
      });
    });
  }

  /* --- Aggiungi al carrello dalla card ----------------------------------- */
  function initCardCart() {
    if (document.body.dataset.zpkCartBound) return;
    document.body.dataset.zpkCartBound = '1';
    document.addEventListener('click', async (event) => {
      const btn = event.target.closest('[data-zpk-add]');
      if (!btn) return;
      event.preventDefault();
      const id = btn.dataset.zpkAdd;
      if (!id || btn.disabled) return;

      const label = btn.getAttribute('aria-label');
      btn.disabled = true;
      try {
        const res = await fetch(window.Shopify?.routes?.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('cart/add failed');
        btn.setAttribute('aria-label', btn.dataset.zpkAddedLabel || label);
        announce((btn.dataset.zpkAddedMessage || 'Aggiunto al carrello') + '.');
        refreshCartCount();
        if (!openSideCart(btn)) window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (e) {
        announce('Non e\' stato possibile aggiungere al carrello.');
        window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } finally {
        btn.disabled = false;
      }
    });
  }

  /* --- «Compra» nella scheda prodotto: carrello laterale -----------------
     Il modulo della scheda andava a /cart/add come un modulo qualunque e
     Shopify rispondeva aprendo la pagina del carrello; dalle card invece si
     apre il carrello laterale (qui sopra). Richiesta del 24/9/2026: la
     stessa cosa anche qui. Se il pannello non c'e', il modulo parte come
     prima; se Shopify rifiuta (per esempio tutte le copie disponibili sono
     gia' nel carrello) il motivo si scrive sotto il bottone. */
  function productFormMessage(form, text) {
    let msg = form.querySelector('.zpk-buy__error');
    if (!text) { if (msg) msg.remove(); return; }
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'zpk-buy__error';
      msg.setAttribute('role', 'alert');
      form.appendChild(msg);
    }
    msg.textContent = text;
  }

  function initProductForm(root) {
    $$('#zpk-product-form', root).forEach((form) => {
      if (form.dataset.zpkBound) return;
      form.dataset.zpkBound = '1';
      form.addEventListener('submit', async (event) => {
        if (!window.ajaxCart || typeof window.ajaxCart.load !== 'function' || !document.getElementById('cart')) return;
        event.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn && btn.disabled) return;
        if (btn) btn.disabled = true;
        try {
          const res = await fetch(cartRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            productFormMessage(form, data.description || data.message || 'Non è stato possibile aggiungere al carrello.');
            return;
          }
          productFormMessage(form, '');
          announce('Aggiunto al carrello.');
          refreshCartCount();
          openSideCart(btn);
        } catch (e) {
          form.submit();
        } finally {
          if (btn) btn.disabled = false;
        }
      });
    });
  }

  /* --- Scheda prodotto: «lista dei desideri» diverso da «Compra» ----------
     Magic Wishlist colora il suo bottone con uno stile in linea !important
     preso dalle proprie impostazioni, che nessun foglio batte. Su Edizioni
     BD il colore scelto nell'app e' il viola del «Compra», e i due bottoni
     sembravano uguali (24/9/2026). Solo quando i due fondi coincidono si
     tolgono al bottone dell'app i colori in linea e diventa il bottone
     secondario: bianco con bordo e testo del colore di «Compra»
     (zpk-apps.css, §10-bis). Se l'app li rimette, si ritolgono. */
  function initWishlistContrast(root) {
    $$('.zpk-buy', root).forEach((buyCol) => {
      if (buyCol.dataset.zpkWlBound) return;
      const buy = buyCol.querySelector('#zpk-product-form [type="submit"]');
      if (!buy) return;
      buyCol.dataset.zpkWlBound = '1';
      // Si confronta il colore SCRITTO dall'app, non quello a video: il
      // bottone ha una transizione sul fondo, e appena l'app lo colora mostra
      // ancora il colore di prima. Un elemento di appoggio porta i due valori
      // nello stesso formato (rgb).
      const toRgb = (value) => {
        const probe = document.createElement('span');
        probe.style.display = 'none';
        probe.style.color = value;
        document.body.appendChild(probe);
        const rgb = getComputedStyle(probe).color;
        probe.remove();
        return rgb;
      };
      const fix = () => {
        const target = toRgb(getComputedStyle(buy).backgroundColor);
        $$(':scope > .shopify-app-block button, :scope > [id^="shopify-block-"] button', buyCol).forEach((b) => {
          const inline = b.style.getPropertyValue('background-color') || b.style.getPropertyValue('background');
          if (!inline || toRgb(inline) !== target) return;
          ['background', 'background-color', 'border', 'border-color', 'color'].forEach((p) => b.style.removeProperty(p));
          // Non il grigio (l'utente non lo voleva, 24/9/2026): bianco con
          // bordo e testo del colore di «Compra», il bottone secondario
          // accanto al pieno (zpk-apps.css, §10-bis).
          b.classList.add('zpk-wl-outline');
        });
      };
      fix();
      new MutationObserver(fix).observe(buyCol, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
    });
  }

  /* --- Carrello laterale e numero nell'header ----------------------------
     Il carrello laterale e' quello di Xtra (sections/side-cart.liquid, id
     «cart»): ajaxCart.load() lo richiede al server e lo apre, con il prodotto
     appena aggiunto e i bottoni per la cassa. Prima il bottone della card
     aggiungeva in silenzio: niente a video, e il numero in alto restava
     fermo fino al ricaricamento della pagina.

     L'header J-POP non e' quello di Xtra, quindi il suo numero non lo
     aggiornava nessuno. Ogni volta che il carrello laterale si ridisegna
     (aggiunta, quantita' cambiata, riga tolta) il suo <header data-totalqty>
     porta il totale giusto: lo si ricopia sul numero. */
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  let cartTrigger = null;

  function openSideCart(trigger) {
    if (!window.ajaxCart || typeof window.ajaxCart.load !== 'function' || !document.getElementById('cart')) return false;
    cartTrigger = trigger || null;
    window.ajaxCart.load(false, true, false, true);
    return true;
  }

  function setCartCount(count) {
    const n = Number(count);
    if (!Number.isFinite(n)) return;
    $$('.zpk-header__badge').forEach((badge) => {
      const grew = n > Number(badge.textContent);
      badge.textContent = String(n);
      const link = badge.closest('a');
      if (link) link.setAttribute('aria-label', `Carrello, ${n} ${n === 1 ? 'articolo' : 'articoli'}`);
      if (grew) {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;   // riparte l'animazione anche a due aggiunte di fila
        badge.classList.add('is-bumped');
      }
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
      if (res.ok) setCartCount((await res.json()).item_count);
    } catch (e) { /* il numero resta quello di prima */ }
  }

  function initCartSync() {
    if (document.body.dataset.zpkCartSync) return;
    document.body.dataset.zpkCartSync = '1';
    const panel = document.getElementById('cart');
    if (panel) {
      new MutationObserver(() => {
        const qty = panel.querySelector('[data-totalqty]');
        if (qty) setCartCount(qty.dataset.totalqty);
        // Chiuso il carrello aperto da una card, il fuoco torna sul bottone
        // (Xtra lo riporta solo sui propri link): da tastiera non si riparte
        // dall'inizio della pagina.
        if (panel.getAttribute('aria-hidden') === 'true' && cartTrigger) {
          const trigger = cartTrigger;
          cartTrigger = null;
          window.setTimeout(() => {
            if (!document.activeElement || document.activeElement === document.body) trigger.focus({ preventScroll: true });
          }, 150);
        }
      }).observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'data-totalqty'] });
    }
    // Clic sullo sfondo scuro: chiude il pannello aperto (vedi zpk-theme.css).
    // Gli strati sono due: col pannello aperto il CSS di Xtra rende attivo
    // anche .overlay-close-clipping, che sta sopra e riceve lui il clic.
    // Sono solo per il mouse: da tastiera ci sono la X ed Esc, quindi non
    // entrano nell'ordine di tabulazione.
    $$('#root > .overlay-close, #root > .overlay-close-clipping').forEach((backdrop) => {
      backdrop.setAttribute('tabindex', '-1');
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('click', (event) => {
        if (!document.documentElement.classList.contains('m6pn-open')) return;
        event.preventDefault();
        if (typeof window.hidePanels === 'function') window.hidePanels();
      });
    });

    // Tornando indietro col browser la pagina puo' arrivare dalla cache con
    // il numero vecchio.
    window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCartCount(); });
  }

  /* --- «Condividi» nella scheda prodotto ---------------------------------
     Il bottone c'era (sections/zpk-product-main.liquid) ma nessuno script lo
     ascoltava: premuto, non succedeva niente, ne' a video ne' per lo screen
     reader. Dove il sistema offre la condivisione nativa (telefoni, Safari,
     Edge) si apre quella; altrove si copia il link e lo si dice con la
     regione di annuncio (WCAG 4.1.3). Se anche la copia e' negata, si
     annuncia l'indirizzo, cosi' il comando non resta muto. */
  function initShare() {
    if (document.body.dataset.zpkShareBound) return;
    document.body.dataset.zpkShareBound = '1';
    document.addEventListener('click', async (event) => {
      const btn = event.target.closest('[data-zpk-share]');
      if (!btn) return;
      const url = btn.dataset.zpkShareUrl || window.location.href;
      const title = btn.dataset.zpkShareTitle || document.title;
      if (navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (e) {
          // Annullata dall'utente: non e' un errore, e non si copia al suo posto.
          if (e && e.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        announce('Link copiato negli appunti.');
      } catch (e) {
        announce('Indirizzo della pagina: ' + url);
      }
    });
  }

  /* --- Cuori di Magic Wishlist: il nome del prodotto nell'etichetta -------
     L'app mette su ogni card lo stesso aria-label, «Aggiungi alla lista dei
     desideri»: in una griglia di 20 volumi lo screen reader legge 20 bottoni
     identici e non si capisce quale sia quale (WCAG 2.4.6). Il titolo l'app
     lo scrive gia' nel bottone, in data-product-title: lo si aggiunge in
     coda. L'etichetta dell'app resta in testa (WCAG 2.5.3) e quando l'app la
     cambia (per esempio a prodotto gia' in lista) il titolo si riaggiunge. Il
     bottone della scheda prodotto non ha data-product-title e non serve: li'
     il prodotto e' uno solo. */
  function labelWishlist(btn) {
    const title = btn.dataset.productTitle;
    const label = btn.getAttribute('aria-label');
    if (!title || !label || label.includes(title)) return;
    btn.setAttribute('aria-label', label + ': ' + title);
  }

  function initWishlistLabels() {
    if (document.body.dataset.zpkWishlistLabels) return;
    document.body.dataset.zpkWishlistLabels = '1';
    const SELECTOR = 'button[data-product-title][aria-label]';
    $$(SELECTOR).forEach(labelWishlist);
    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === 'attributes') {
          if (m.target.matches && m.target.matches(SELECTOR)) labelWishlist(m.target);
          return;
        }
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches(SELECTOR)) labelWishlist(node);
          $$(SELECTOR, node).forEach(labelWishlist);
        });
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label'] });
  }

  /* --- Accessibilità di app e pannelli (verifica del 6/10/2026) ------------
     Verifica automatica (axe, WCAG 2.2 AA) e prove da tastiera sui siti veri.
     Sono tutte cose che il nostro HTML non contiene: arrivano a pagina caricata.

     1. Cuore di Magic Wishlist sulle card. L'app lo infila nella copertina
        (.zpk-card__media), che e' un link doppione nascosto ai lettori di
        schermo (aria-hidden, tabindex -1). Il cuore si raggiungeva con Tab ma
        il lettore restava muto (WCAG 4.1.2). Lo si sposta subito dopo la
        copertina, come figlio diretto della card: zpk-apps.css §1-bis lo
        mette nello stesso angolo, a vista non cambia nulla.
     2. Cuore della wishlist nell'intestazione e suo pannello. Il cuore e' un
        <div role="button"> senza tabindex: con la tastiera non ci si arrivava
        (2.1.1). Il pannello (.wishlist-drawer, aperto = .active) non aveva
        ruolo ne' nome, e il fuoco restava sulla pagina dietro. Anche il campo
        del link da condividere era senza nome.
     3. Carrello laterale di Xtra (aside#cart, aperto = aria-hidden="false").
        Non aveva ruolo ne' nome, e con Tab si usciva verso la pagina coperta
        dal pannello (2.4.11). Da chiuso ha visibility:hidden ed e' fuori
        dall'albero dell'accessibilita', quindi ruolo e nome restano fissi.
        Xtra aggiunge ai pannelli un link «Close» in inglese: si chiama «Chiudi».
     Finche' un pannello e' aperto il fuoco gira dentro (Tab, Maiusc+Tab).
     Quando si chiude, se il fuoco e' rimasto nel vuoto torna dove si era prima. */
  const FOCUSABILI = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusabili(box) {
    return $$(FOCUSABILI, box).filter((el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }

  function aperto(el) {
    return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  function liftCardHearts() {
    $$('.zpk-card__media .wishlist-heart-container, .zpk-card__media .wishlist-heart-btn').forEach((el) => {
      const media = el.closest('.zpk-card__media');
      const card = media && media.closest('.zpk-card');
      if (!card) return;
      const box = el.closest('.wishlist-heart-container') || el;
      if (!media.contains(box)) return;
      // Un cuore fuori dalla copertina c'e' gia': questo e' un doppione.
      if (card.querySelector(':scope > .wishlist-heart-container, :scope > .wishlist-heart-btn')) box.remove();
      else media.after(box);
    });
  }

  /* Magic Wishlist mette i cuori solo nelle card che trova quando parte: i
     caroselli che arrivano dopo (Ultime uscite, Bestseller, Dal manga
     all'anime, Di nuovo disponibili) restavano senza (6/10/2026). Quando
     compaiono card senza cuore gli si chiede un altro giro con la stessa
     funzione che usa all'avvio (processAllProducts). Un giro alla volta, e
     solo se il numero di card senza cuore e' cambiato: le card che l'app non
     sa gestire non la fanno ripartire all'infinito. */
  let senzaCuore = 0;
  let giroInCorso = false;
  function heartsForLateCards() {
    const app = window.wishlistApp;
    if (!app || typeof app.processAllProducts !== 'function' || giroInCorso) return;
    const n = $$('.zpk-card').filter((c) => !c.querySelector('.wishlist-heart-btn')).length;
    if (!n || n === senzaCuore) return;
    senzaCuore = n;
    giroInCorso = true;
    Promise.resolve()
      .then(() => app.processAllProducts())
      .catch(() => {})
      .finally(() => { giroInCorso = false; });
  }

  function labelPanels() {
    const cart = $('aside#cart');
    if (cart && !cart.hasAttribute('role')) {
      cart.setAttribute('role', 'dialog');
      cart.setAttribute('aria-modal', 'true');
      cart.setAttribute('aria-label', 'Carrello');
    }
    $$('a.m6pn-close').forEach((a) => {
      if (a.textContent.trim() === 'Close' && a.getAttribute('aria-label') !== 'Chiudi') a.setAttribute('aria-label', 'Chiudi');
    });
    $$('[data-wishlist-header][role="button"]:not([tabindex])').forEach((el) => el.setAttribute('tabindex', '0'));
    const inner = $('.wishlist-drawer__inner');
    if (inner && !inner.hasAttribute('role')) {
      const title = $('.wishlist-drawer__title', inner);
      if (title && !title.id) title.id = 'zpk-wishlist-title';
      inner.setAttribute('role', 'dialog');
      inner.setAttribute('aria-modal', 'true');
      if (title) inner.setAttribute('aria-labelledby', title.id);
      else inner.setAttribute('aria-label', 'La tua lista dei desideri');
    }
    const share = $('.wishlist-share-modal');
    if (share && !share.hasAttribute('role')) {
      share.setAttribute('role', 'dialog');
      share.setAttribute('aria-modal', 'true');
      share.setAttribute('aria-label', 'Condividi la lista dei desideri');
    }
    $$('.wishlist-share-modal__link-input:not([aria-label])').forEach((el) => el.setAttribute('aria-label', 'Link della tua lista dei desideri'));
  }

  // Il pannello aperto in primo piano: condivisione > wishlist > carrello.
  function pannelloAperto() {
    const share = $('.wishlist-share-modal');
    if ($('.wishlist-drawer.active') && aperto(share) && focusabili(share).length) return share;
    if ($('.wishlist-drawer.active')) return $('.wishlist-drawer__inner') || $('.wishlist-drawer');
    const cart = $('aside#cart[aria-hidden="false"]');
    return aperto(cart) ? cart : null;
  }

  function initPanelsA11y() {
    if (document.body.dataset.zpkPanelsA11y) return;
    document.body.dataset.zpkPanelsA11y = '1';
    const PANNELLI = 'aside#cart, .wishlist-drawer';
    let ultimoFuori = null;
    let prima = null;

    document.addEventListener('focusin', (event) => {
      if (!event.target.closest(PANNELLI)) ultimoFuori = event.target;
    });

    // Cuore dell'intestazione: Invio e Spazio come un clic.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const btn = event.target.closest && event.target.closest('[data-wishlist-header][role="button"]');
      if (!btn) return;
      event.preventDefault();
      btn.click();
    });

    // Tab e Maiusc+Tab restano dentro il pannello aperto.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const box = pannelloAperto();
      if (!box) return;
      const lista = focusabili(box);
      if (!lista.length) return;
      const primo = lista[0];
      const ultimo = lista[lista.length - 1];
      const qui = document.activeElement;
      if (!box.contains(qui)) { event.preventDefault(); primo.focus(); }
      else if (event.shiftKey && qui === primo) { event.preventDefault(); ultimo.focus(); }
      else if (!event.shiftKey && qui === ultimo) { event.preventDefault(); primo.focus(); }
    });

    // Apertura e chiusura: il fuoco entra nel pannello e, chiuso, torna indietro.
    const controlla = () => {
      const ora = pannelloAperto();
      if (ora === prima) return;
      if (ora && !ora.contains(document.activeElement)) {
        const chiudi = $('.wishlist-drawer__close, .wishlist-share-modal__close', ora);
        (chiudi && aperto(chiudi) ? chiudi : focusabili(ora)[0])?.focus();
      }
      if (!ora && prima) {
        const qui = document.activeElement;
        if ((!qui || qui === document.body || prima.contains(qui)) && ultimoFuori && document.contains(ultimoFuori)) ultimoFuori.focus();
      }
      prima = ora;
    };
    const osservaStato = new MutationObserver(() => setTimeout(controlla, 0));
    const osservati = new Set();
    const aggancia = () => {
      $$('aside#cart, .wishlist-drawer, .wishlist-share-modal').forEach((el) => {
        if (osservati.has(el)) return;
        osservati.add(el);
        osservaStato.observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });
      });
    };

    let queued = false;
    const run = () => {
      queued = false;
      heartsForLateCards();
      liftCardHearts();
      labelPanels();
      aggancia();
    };
    run();
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(run, 50);
    }).observe(document.body, { subtree: true, childList: true });
  }

  /* --- «Gestisci le preferenze sui cookie» --------------------------------
     Qualunque link che punta a #preferenze-cookie (la pagina Cookie policy,
     il piè di pagina) riapre le preferenze del banner cookie di Shopify con
     window.privacyBanner.showPreferences() (Customer Privacy API). Se il
     banner non è attivo quell'oggetto non esiste: il link verrebbe premuto
     senza effetto, quindi lo si nasconde. */
  const COOKIE_LINK = 'a[href$="#preferenze-cookie"]';

  function initCookiePreferences() {
    if (document.body.dataset.zpkCookieBound) return;
    document.body.dataset.zpkCookieBound = '1';
    document.addEventListener('click', (event) => {
      const link = event.target.closest(COOKIE_LINK);
      if (!link || !window.privacyBanner?.showPreferences) return;
      event.preventDefault();
      window.privacyBanner.showPreferences();
    });
    // Lo script del banner arriva dopo il nostro: si controlla a pagina caricata.
    window.addEventListener('load', () => {
      window.setTimeout(() => {
        if (window.privacyBanner?.showPreferences) return;
        $$(COOKIE_LINK).forEach((link) => { (link.closest('li') || link).hidden = true; });
      }, 1500);
    });
  }

  /* --- Caroselli caricati dopo ------------------------------------------
     Alcuni caroselli hanno bisogno di un'altra pagina: la collezione
     riordinata (piu' recenti, piu' venduti), i volumi della serie, i titoli
     dello stesso genere, i consigliati di Shopify. La sezione stampa titolo
     e posto vuoto; qui si chiede la stessa sezione a quegli indirizzi
     (data-zpk-remote, anche piu' d'uno separati da spazio) e si prendono le
     card. Le richieste partono insieme ma si inseriscono nell'ordine della
     pagina: cosi' «non ripetere» sa quali prodotti sono gia' comparsi sopra. */
  async function initRemoteCarousels(root) {
    const sections = $$('[data-zpk-remote]', root).filter((section) => !section.dataset.zpkBound);
    sections.forEach((section) => { section.dataset.zpkBound = '1'; });
    const pending = sections.map((section) => Promise.all(
      section.dataset.zpkRemote.split(' ').filter(Boolean).map((url) =>
        fetch(url).then((res) => (res.ok ? res.text() : '')).catch(() => ''))
    ));
    for (let i = 0; i < sections.length; i++) {
      fillRemote(sections[i], await pending[i]);
    }
  }

  function fillRemote(section, pages) {
    let carousel = null;
    const cards = [];
    pages.forEach((text) => {
      if (!text) return;
      const found = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-zpk-carousel]');
      if (!found) return;
      carousel = carousel || found;
      cards.push(...$$('[data-zpk-track] > *', found));
    });

    const slot = $('[data-zpk-slot]', section);
    const picked = carousel ? pickCards(section, cards) : [];
    if (!slot) return;
    if (!picked.length) {
      // Nel theme editor la sezione resta, con la riga che spiega perche' e' vuota.
      const hint = $('[data-zpk-empty]', section);
      if (window.Shopify && window.Shopify.designMode && hint) {
        slot.replaceChildren(hint);
        hint.hidden = false;
      } else {
        section.hidden = true;
      }
      return;
    }
    $('[data-zpk-track]', carousel).replaceChildren(...picked);
    slot.replaceWith(carousel);
    section.hidden = false;
    boot(section);
  }

  function pickCards(section, cards) {
    const data = section.dataset;
    const limit = Number(data.zpkLimit) || 8;
    const id = (card) => card.dataset.zpkProductId;

    if (data.zpkMode === 'series') return pickVolumes(cards, data.zpkCurrent, limit);

    const shown = 'zpkSkipShown' in data ? shownBefore(section) : new Set();
    let list = cards.filter((card) => id(card) !== data.zpkCurrent && !shown.has(id(card)));

    if (data.zpkMode === 'similar') {
      // Prima i titoli con piu' generi in comune; a parita', l'ordine di
      // arrivo (le serie piu' recenti). Un titolo per serie, mai la serie aperta.
      const mine = new Set((data.zpkTags || '').split(' ').filter(Boolean));
      const score = (card) => (card.dataset.zpkTags || '').split(' ').filter((tag) => mine.has(tag)).length;
      const seen = new Set();
      list = list
        .map((card, i) => ({ card, i, s: score(card) }))
        .sort((a, b) => b.s - a.s || a.i - b.i)
        .map((entry) => entry.card)
        .filter((card) => {
          const series = card.dataset.zpkSeries;
          if (series && series === data.zpkSeries) return false;
          const key = series || id(card);
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
    } else {
      const seen = new Set();
      list = list.filter((card) => !seen.has(id(card)) && seen.add(id(card)));
      // Due collezioni unite (es. tutti i prodotti + in preordine): ciascuna
      // arriva gia' in ordine di data di uscita, qui si rimettono insieme.
      if (data.zpkSort === 'release-descending' || data.zpkSort === 'release-ascending') {
        const dir = data.zpkSort === 'release-descending' ? -1 : 1;
        const when = (card) => Number(card.dataset.zpkRelease) || 0;
        list = list
          .map((card, i) => ({ card, i }))
          .sort((a, b) => dir * (when(a.card) - when(b.card)) || a.i - b.i)
          .map((entry) => entry.card);
      }
    }
    return list.slice(0, limit);
  }

  // Prodotti gia' visibili nei caroselli che stanno sopra questa sezione.
  function shownBefore(section) {
    return new Set($$('[data-zpk-carousel] [data-zpk-product-id]')
      .filter((card) => section.compareDocumentPosition(card) & Node.DOCUMENT_POSITION_PRECEDING)
      .map((card) => card.dataset.zpkProductId));
  }

  // Una serie lunga (Kingdom ha 75 volumi) arriva intera e in ordine: si
  // toglie il volume aperto e se ne tengono `limit` vicini, prima i
  // successivi; verso la fine della serie si completa con i precedenti.
  // Dal 9/10/2026 l'ordine e' per data di uscita DALLA PIU' RECENTE: i
  // successivi al volume aperto stanno PRIMA di lui nell'elenco, quindi la
  // finestra finisce dove stava il volume aperto (e se davanti non ce ne
  // sono abbastanza si allunga sui precedenti, che vengono dopo).
  function pickVolumes(cards, currentId, limit) {
    const list = cards.slice();
    const at = currentId ? list.findIndex((card) => card.dataset.zpkProductId === currentId) : -1;
    if (at > -1) list.splice(at, 1);
    const start = at > -1 ? Math.max(0, Math.min(at - limit, list.length - limit)) : 0;
    return list.slice(start, start + limit);
  }

  /* --- Visti di recente -------------------------------------------------
     L'elenco lo scrive il tema (custom-async.js, localStorage
     «recentlyViewedProduct») a ogni scheda prodotto aperta: [{productUrl,
     productId}], dal piu' vecchio al piu' nuovo. Ogni prodotto si chiede alla
     sezione zpk-card-item, che stampa la stessa card dei caroselli. Le card
     vanno dal piu' recente, senza il prodotto aperto. Senza elenco (o con il
     browser che non lascia leggere localStorage) la sezione resta nascosta.
     Prima qui c'era la sezione di Xtra, con la sua card: diversa dalle altre
     e rotta sulla copertina «in arrivo». */
  function readRecent() {
    try {
      const list = JSON.parse(window.localStorage.getItem('recentlyViewedProduct') || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  async function initRecent(root) {
    const sections = $$('[data-zpk-recent]', root).filter((section) => !section.dataset.zpkBound);
    for (const section of sections) {
      section.dataset.zpkBound = '1';
      const limit = Number(section.dataset.zpkLimit) || 8;
      const current = section.dataset.zpkCurrent;
      const items = readRecent().reverse()
        .filter((item) => item && typeof item.productUrl === 'string' && String(item.productId) !== current)
        .slice(0, limit);
      const pages = await Promise.all(items.map((item) =>
        fetch(item.productUrl.split('?')[0] + '?section_id=zpk-card-item')
          .then((res) => (res.ok ? res.text() : ''))
          .catch(() => '')));
      const cards = pages
        .map((text) => text && new DOMParser().parseFromString(text, 'text/html').querySelector('[data-zpk-track] > *'))
        .filter(Boolean);
      const wrap = $('[data-zpk-recent-carousel]', section);
      if (!cards.length || !wrap) {
        if (!(window.Shopify && window.Shopify.designMode)) section.hidden = true;
        continue;
      }
      $('[data-zpk-track]', wrap).replaceChildren(...cards);
      // Il carosello si aggancia solo ora, con le card dentro: le frecce
      // compaiono se c'e' davvero da scorrere.
      wrap.setAttribute('data-zpk-carousel', '');
      $$('[data-zpk-empty]', section).forEach((hint) => { hint.hidden = true; });
      section.hidden = false;
      boot(section);
    }
  }

  /* --- Avvio ------------------------------------------------------------- */
  function boot(root) {
    initPromo(root);
    initCarousels(root);
    initMoods(root);
    initHero(root);
    initProductForm(root);
    initWishlistContrast(root);
    initQty(root);
    initGallery(root);
    initReadMore(root);
    initRemoteCarousels(root);
    initRecent(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    boot(document);
    initMobileMenu();
    initAccount();
    initCardCart();
    initCartSync();
    initShare();
    initWishlistLabels();
    initPanelsA11y();
    initCookiePreferences();
  });

  // Il theme editor rimonta le sezioni: ri-inizializziamo solo quella toccata.
  document.addEventListener('shopify:section:load', (event) => boot(event.target));

  // «Specifiche» su computer vive dentro la scheda prodotto (la sposta lo
  // script di zpk-product-detail): se l'editor rimonta la scheda, la tabella
  // torna prima a casa, se no sparirebbe con la sezione vecchia; dopo risale.
  document.addEventListener('shopify:section:unload', (event) => {
    const specs = event.target.querySelector('[data-zpk-specs]');
    const home = document.querySelector('[data-zpk-specs-home]');
    if (specs && home && !event.target.contains(home)) home.appendChild(specs);
  });
  document.addEventListener('shopify:section:load', () => window.zpkPlaceSpecs?.());

  // Il theme editor segnala il blocco scelto nella barra laterale: se e' un
  // mood di «Il tuo mood», lo si mostra. L'evento arriva sull'elemento che
  // porta block.shopify_attributes, cioe' il pannello del mood.
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target && event.target.closest ? event.target.closest('[data-zpk-mood]') : null;
    const wrap = panel && panel.closest('[data-zpk-moods]');
    if (wrap && wrap.zpkShowMood) wrap.zpkShowMood(panel);
  });
})();